// extracted by mini-css-extract-plugin
module.exports = {"text_area_container":"TextArea_text_area_container__2XiTv","textarea_label":"TextArea_textarea_label__jF_cc","editor":"TextArea_editor__3PNOC"};